<template>
	<div class="p-grid p-fluid p-justify-center" style="margin-top: -40px;">
		<HomeHeader />
		<AgentHome1 />
		<HomeTeams class="margin-teams" />
		<AgentHome2 />
		<AgentHome3 class="margin-home3" />
		<AgentHome4 class="margin-home4" />
		<AgentHome5 class="margin-home5" />
		<AgentHome6 class="margin-home6" />
		<AgentEndButton />
		<HomeFoot />
	</div>
</template>

<script>
import AuthService from "@/service/AuthService";
import CommonService from "@/service/CommonService";
import HomeHeader from "@/components/home/HomeHeader";
import HomeFoot from "@/components/home/HomeFoot";
import HomeTeams from "@/components/home/HomeTeams";
import AgentHome1 from "@/components/home/agent/AgentHome1";
import AgentHome2 from "@/components/home/agent/AgentHome2";
import AgentHome3 from "@/components/home/agent/AgentHome3";
import AgentHome4 from "@/components/home/agent/AgentHome4";
import AgentHome5 from "@/components/home/agent/AgentHome5";
import AgentHome6 from "@/components/home/agent/AgentHome6";
import AgentEndButton from "@/components/home/agent/AgentEndButton";

export default {
	components: {
		HomeHeader,
		HomeFoot,
		HomeTeams,
		AgentHome1,
		AgentHome2,
		AgentHome3,
		AgentHome4,
		AgentHome5,
		AgentHome6,
		AgentEndButton,
	},
	data() {
		return {
			email: "",
			password: "",
			loginClicked: false,
		};
	},
	beforeCreate: function () {
		document.body.className = "login";
	},
	authService: null,
	commonService: null,
	created() {
		this.authService = new AuthService();
		this.commonService = new CommonService();
	},
	methods: {
		login() {
			this.$router.push("/login");
		},
		register() {
			this.$router.push("/register");
		},
	},
};
</script>

<style scoped>
.margin-teams {
	margin-top: -20px;
	margin-bottom: -20px;
}

.margin-home3 {
	margin-top: 50px;
}

.margin-home4 {
	margin-top: 50px;
}

.margin-home5 {
	margin-top: -100px;
}

.margin-home6 {
	margin-top: -60px;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.margin-teams {
		margin-top: -60px;
		margin-bottom: 0px;
	}

	.margin-home3 {
		margin-top: 0px;
	}

	.margin-home4 {
		margin-top: 0px;
	}

	.margin-home5 {
		margin-top: 0px;
	}

	.margin-home6 {
		margin-top: 0px;
	}
}

@media (min-width: 1000px) and (max-width: 1500px) {
	.margin-teams {
		margin-top: -40px;
		margin-bottom: 20px;
	}

	.margin-home5 {
		margin-top: 10px;
	}

	.margin-home6 {
		margin-top: 50px;
	}
}
</style>
